
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { defineComponent } from 'vue';

import { MAX_DECIMAL_PLACES, MIN_DECIMAL_PLACES, clampDecimalPlaces } from '@/shared/handsontable/decimalPlaces';

library.add(faMinusCircle, faPlusCircle);

/**
 * A small stepper (- value +) to configure the number of decimal places of a numeric column.
 * Used in the table settings modal (@/shared/components/ModalPageSettings.vue).
 *
 * @category Shared
 * @subcategory Form
 * @component
 */
export default defineComponent({
  name: 'DecimalPlacesStepper',
  props: {
    value: {
      type: Number,
      default: MIN_DECIMAL_PLACES,
    },
    min: {
      type: Number,
      default: MIN_DECIMAL_PLACES,
    },
    max: {
      type: Number,
      default: MAX_DECIMAL_PLACES,
    },
  },
  methods: {
    decrement() {
      if (this.value <= this.min) return;
      this.$emit('input', clampDecimalPlaces(this.value - 1));
    },
    increment() {
      if (this.value >= this.max) return;
      this.$emit('input', clampDecimalPlaces(this.value + 1));
    },
  },
});
